import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const authHeaders = () => {
  const raw = localStorage.getItem("userDetails");
  const token = raw ? JSON.parse(raw)?.token : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createDailyMaterialReportApi = (data) =>
  axios.post(`${API_BASE_URL}/api/dpr/daily-material`, data, {
    headers: authHeaders(),
  });

export const updateDailyMaterialReportApi = (id, data) =>
  axios.put(`${API_BASE_URL}/api/dpr/daily-material/${id}`, data, {
    headers: authHeaders(),
  });
